<template>
  <div class="wrapper">
    <div class="title">Instructions de jeu</div>
    <img
      src="@/assets/images/img/game-instructions.png"
      alt="Instructions de jeu"
    />
  </div>
</template>
